import React from "react";
import AsesorAdmin from "./assets/AsesorAdmin.jpg";
import DesarrolloWeb from "./assets/DesarrolloWeb.jpg";
import { Briefcase, Laptop} from "lucide-react";

function Services() {
  const servicios = [
    {
      id: 1,
      titulo: "Asesoramiento Administrativo",
      descripcion:
        "Optimizamos tus procesos administrativos para que gestiones tu negocio de forma ágil, clara y organizada. Te acompañamos en cada etapa de tu emprendimiento con un enfoque práctico y humano.",
      imagen: AsesorAdmin,
      detalles: [
        "Gestión integral de emprendimientos",
        "Organización contable y financiera",
        "Análisis de costos y rentabilidad",
        "Implementación de herramientas digitales",
      ],
      icon: <Briefcase className="w-8 h-8 text-[var(--color-accent)]" />,
    },
    {
      id: 2,
      titulo: "Desarrollo Web",
      descripcion:
        "Creamos soluciones digitales escalables, adaptadas a tu negocio. Combinamos diseño, estrategia y tecnología para potenciar tu presencia online.",
      imagen: DesarrolloWeb,
      detalles: [
        "Landing Pages profesionales",
        "E-commerce y tiendas online",
        "Sistemas de gestión personalizados",
        "Diseño responsive y SEO",
      ],
      icon: <Laptop className="w-8 h-8 text-[var(--color-accent)]" />,
    },
  ];

  return (
    <section id="servicios" className="bg-[var(--color-bg)] py-24">
      <div className="container text-center max-w-6xl mx-auto px-6">
        {/* Título principal */}
        <h2 className="text-4xl font-bold mb-16 text-[var(--color-dark)]">
          Nuestros <span className="text-[var(--color-accent)]">Servicios</span>
        </h2>

        {/* Cards */}
        <div className="grid md:grid-cols-2 gap-12">
          {servicios.map((serv) => (
            <div
              key={serv.id}
              className="bg-white rounded-2xl shadow-sm hover:shadow-lg transition-all duration-300 overflow-hidden flex flex-col"
            >
              {/* Imagen superior */}
              <img
                src={serv.imagen}
                alt={serv.titulo}
                className="w-full h-56 object-cover"
              />

              {/* Contenido */}
              <div className="p-8 flex flex-col flex-grow">
                <div className="flex items-center justify-center mb-4">
                  {serv.icon}
                </div>
                <h3 className="text-2xl font-semibold mb-3 text-[var(--color-dark)]">
                  {serv.titulo}
                </h3>
                <p className="text-base opacity-90 leading-relaxed mb-6">
                  {serv.descripcion}
                </p>

                {/* Subcategorías */}
                <ul className="text-left space-y-2 mx-auto text-[var(--color-dark)] font-medium max-w-xs">
                  {serv.detalles.map((detalle, i) => (
                    <li key={i} className="flex items-start gap-2">
                      <span className="text-[var(--color-accent)]">•</span>
                      <span className="opacity-90">{detalle}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Services;

